<template>
  <v-container fluid mb-4>
    <v-row justify="center">
      <v-col cols="12" lg="9">
        <v-card>
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-toolbar-title>
              {{ $t('Создание торговой процедуры') }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-list>
              <v-list-item
                  v-for="(item, ind) in lotTypes"
                  :key="ind"
                  v-test="{ listItem: item.type }"
                  link
                  @click="goToRoute(`${urlRootPath}/lotWizard/${item.type}`)">
                <v-list-item-icon>
                  <v-icon v-text="'gavel'" />
                </v-list-item-icon>
                <v-list-item-content class="text-left align-self-start">
                  <v-list-item-title v-text="item.name" />
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { LOT_TYPE_ENUM } from '@/constants/enums'
  export default {
    computed: {
      lotTypes () {
        return Object.keys(LOT_TYPE_ENUM).map(key => ({
          type: key,
          name: this.$t(LOT_TYPE_ENUM[key])
        }))
      }
    }
  }
</script>
